import { put, takeLatest } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import {
    GET_TARIFF_HEADS,
    GET_TARIFF_HEADS_SUCCESS,
    GET_TARIFF_HEADS_FAILURE,
    GET_TARIFF_HEADS_WITH_DETAILS,
    GET_TARIFF_HEADS_WITH_DETAILS_SUCCESS,
    GET_TARIFF_HEADS_WITH_DETAILS_FAILURE,
    GET_TARIFF_HEAD_DETAILS,
    GET_TARIFF_HEAD_DETAILS_SUCCESS,
    GET_TARIFF_HEAD_DETAILS_FAILURE,
    CREATE_TARIFF_HEAD,
    CREATE_TARIFF_HEAD_SUCCESS,
    CREATE_TARIFF_HEAD_FAILURE,
    UPDATE_TARIFF_HEAD,
    UPDATE_TARIFF_HEAD_SUCCESS,
    UPDATE_TARIFF_HEAD_FAILURE,
    UPDATE_TARIFF_HEAD_STATUS,
    UPDATE_TARIFF_HEAD_STATUS_SUCCESS,
    UPDATE_TARIFF_HEAD_STATUS_FAILURE,
    DELETE_TARIFF_HEAD,
    DELETE_TARIFF_HEAD_SUCCESS,
    DELETE_TARIFF_HEAD_FAILURE
} from '../../../actions/index.types';
import {
    getTariffHeadsReq,
    getTariffHeadsWithDetailsReq,
    getTariffHeadDetailsReq,
    createTariffHeadReq,
    updateTariffHeadReq,
    updateTariffHeadStatusReq,
    deleteTariffHeadReq
} from '../../../../axios/request/SocietyPortal/TariffHeadReqs/TariffHeadReqs';

// Get All Tariff Heads Saga
function* getTariffHeadsSaga(action) {
    try {
        const response = yield getTariffHeadsReq(action);
        if (response.success === true) {
            yield put({ type: GET_TARIFF_HEADS_SUCCESS, data: response });
        } else {
            yield put({ type: GET_TARIFF_HEADS_FAILURE, data: response.data });
            toast.error(response.data.message || "Failed to fetch tariff heads");
        }
    } catch (error) {
        yield put({ type: GET_TARIFF_HEADS_FAILURE, data: error });
            toast.error(error?.response?.data?.message || "Something went wrong");
    }
}

// Get Tariff Heads With Details Saga
function* getTariffHeadsWithDetailsSaga(action) {
    try {
        const response = yield getTariffHeadsWithDetailsReq(action);
        if (response.success === true) {
            yield put({ type: GET_TARIFF_HEADS_WITH_DETAILS_SUCCESS, data: response });
        } else {
            yield put({ type: GET_TARIFF_HEADS_WITH_DETAILS_FAILURE, data: response.data });
            toast.error(response.data.message || "Failed to fetch tariff heads with details");
        }
    } catch (error) {
        yield put({ type: GET_TARIFF_HEADS_WITH_DETAILS_FAILURE, data: error });
        toast.error(error?.response?.data?.message || "Something went wrong");
    }
}

// Get Tariff Head Details Saga
function* getTariffHeadDetailsSaga(action) {
    try {
        const response = yield getTariffHeadDetailsReq(action);
        if (response.success === true) {
            yield put({ type: GET_TARIFF_HEAD_DETAILS_SUCCESS, data: response.data.data });
        } else {
            yield put({ type: GET_TARIFF_HEAD_DETAILS_FAILURE, data: response.data });
            toast.error(response.data.message || "Failed to fetch tariff head details");
        }
    } catch (error) {
        yield put({ type: GET_TARIFF_HEAD_DETAILS_FAILURE, data: error });
        toast.error(error?.response?.data?.message || "Something went wrong");
    }
}

// Create Tariff Head Saga
function* createTariffHeadSaga(action) {
    try {
        const response = yield createTariffHeadReq(action);
        if (response.success === true) {
            yield put({ type: CREATE_TARIFF_HEAD_SUCCESS, data: response.data });
            toast.success(response.data.message || "Charge head created successfully");
            if (action?.data?.onSuccess) {
                action.data.onSuccess();
            }
        } else {
            yield put({ type: CREATE_TARIFF_HEAD_FAILURE, data: response.data });
            toast.error(response.data.message || "Failed to create charge head");
        }
    } catch (error) {
        yield put({ type: CREATE_TARIFF_HEAD_FAILURE, data: error });
        toast.error(error?.response?.data?.message || "Something went wrong");
    }
}

// Update Tariff Head Saga
function* updateTariffHeadSaga(action) {
    try {
        const response = yield updateTariffHeadReq(action);
        if (response.success === true) {
            yield put({ type: UPDATE_TARIFF_HEAD_SUCCESS, data: response.data });
            toast.success(response.data.message || "Charge head updated successfully");
            if (action?.data?.onSuccess) {
                action.data.onSuccess();
            }
        } else {
            yield put({ type: UPDATE_TARIFF_HEAD_FAILURE, data: response.data });
            toast.error(response.data.message || "Failed to update charge head");
        }
    } catch (error) {
        yield put({ type: UPDATE_TARIFF_HEAD_FAILURE, data: error });
        toast.error(error?.response?.data?.message || "Something went wrong");
    }
}

// Update Tariff Head Status Saga
function* updateTariffHeadStatusSaga(action) {
    try {
        const response = yield updateTariffHeadStatusReq(action);
        if (response.success === true) {
            yield put({ type: UPDATE_TARIFF_HEAD_STATUS_SUCCESS, data: response.data });
            toast.success(response.data.message || "Status updated successfully");
            if (action?.data?.onSuccess) {
                action.data.onSuccess();
            }
        } else {
            yield put({ type: UPDATE_TARIFF_HEAD_STATUS_FAILURE, data: response.data });
            toast.error(response.data.message || "Failed to update status");
        }
    } catch (error) {
        yield put({ type: UPDATE_TARIFF_HEAD_STATUS_FAILURE, data: error });
        toast.error(error?.response?.data?.message || "Something went wrong");
    }
}

// Delete Tariff Head Saga
function* deleteTariffHeadSaga(action) {
    try {
        const response = yield deleteTariffHeadReq(action);
        if (response.success === true) {
            yield put({ type: DELETE_TARIFF_HEAD_SUCCESS, data: response.data });
            toast.success(response.data.message || "Charge head deleted successfully");
            if (action?.data?.onSuccess) {
                action.data.onSuccess();
            }
        } else {
            yield put({ type: DELETE_TARIFF_HEAD_FAILURE, data: response.data });
            toast.error(response.data.message || "Failed to delete charge head");
        }
    } catch (error) {
        yield put({ type: DELETE_TARIFF_HEAD_FAILURE, data: error });
        toast.error(error?.response?.data?.message || "Something went wrong");
    }
}

export default function* TariffHeadSaga() {
    yield takeLatest(GET_TARIFF_HEADS, getTariffHeadsSaga);
    yield takeLatest(GET_TARIFF_HEADS_WITH_DETAILS, getTariffHeadsWithDetailsSaga);
    yield takeLatest(GET_TARIFF_HEAD_DETAILS, getTariffHeadDetailsSaga);
    yield takeLatest(CREATE_TARIFF_HEAD, createTariffHeadSaga);
    yield takeLatest(UPDATE_TARIFF_HEAD, updateTariffHeadSaga);
    yield takeLatest(UPDATE_TARIFF_HEAD_STATUS, updateTariffHeadStatusSaga);
    yield takeLatest(DELETE_TARIFF_HEAD, deleteTariffHeadSaga);
}
